import Vue from 'vue';
import { gsap } from 'gsap';
import scrollama from 'scrollama';

Vue.component('image-textblock-animation-component', {
    props: [],

    data() {
        return {
        };
    },

    watch: {
    },

    mounted() {
        this.scaleAnimation();
    },

    methods: {
        scaleAnimation() {

            gsap.set('.image-text-block__image', {scale: 1.2})

            // instantiate the scrollama
            const scroller = scrollama();

            // setup the instance, pass callback functions
            scroller
                .setup({
                    step: '.image-text-block__image-holder',
                    offset: 0.5,
                })
                .onStepEnter(response => {
                    // { element, index, direction }
                    gsap.to('.image-text-block__image', {scale: 1, duration: 2, ease: "power3.out"})
                })
                .onStepExit(response => {
                });

            // setup resize event
            window.addEventListener('resize', scroller.resize);
        }

    },

    beforeDestroy() {
    },
});
